export const PLAYER = 'player';
export const BANKER = 'banker';
export const TIE = 'tie';

export const positiveOrNegative = (value) => {
  if (value > 0) {
    return 'is-positive';
  } else if (value < 0) {
    return 'is-negative';
  } else {
    return '';
  }
};

export const calcWinDifference = (x) => Math.abs(9 - x);
